import { render, staticRenderFns } from "./VehiclesModels.vue?vue&type=template&id=57585e79&scoped=true"
import script from "./VehiclesModels.vue?vue&type=script&lang=js"
export * from "./VehiclesModels.vue?vue&type=script&lang=js"
import style0 from "./VehiclesModels.vue?vue&type=style&index=0&id=57585e79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57585e79",
  null
  
)

export default component.exports